import { canViewPropostas } from '@/services/propostasService';

const routeMap = {
  '/propostas': '/pages/propostas',
  '/verificarcontas/contaspendentes': '/pages/contas-pendentes',
  '/verificarcontas/contasaprovadas': '/pages/contas-aprovadas',
  '/verificarcontas/contasrejeitadas': '/pages/contas-rejeitadas',
  '/clientes': '/pages/clientes',
  '/clientes/cadastros': '/pages/clientes',
  '/freelancers': '/pages/freelancers',
  '/freelancers/cadastros': '/pages/freelancers',
  '/freelancers/registros': '/pages/freelancers',
  '/freelancers/lancaratividade': '/pages/lancar-atividade',
  '/freelancers/lancar-atividade': '/pages/lancar-atividade',
  '/freelancers/atividadesativas': '/pages/minhas-atividades',
  '/freelancers/atividades-ativas': '/pages/minhas-atividades',
  '/minhasatividadesfreelancer': '/pages/minhas-atividades-freelancer',
  '/minhas-atividades-freelancer': '/pages/minhas-atividades-freelancer',
  '/metricasfreelancer': '/pages/metricas-freelancer',
  '/metricas-freelancer': '/pages/metricas-freelancer',
  '/freelancers/lancaremlote': '/pages/lancar-em-lote',
  '/2fa': '/pages/2fa',
  '/autenticacao/validar': '/pages/2fa',
  '/usuarios': '/pages/lista-de-usuarios',
  '/usuarios/usuario': '/pages/lista-de-usuarios',
  '/usuarios/cadastrofreelancer': '/pages/cadastro-freelancer',
  '/relatorios': '/pages/relatorios',
  '/relatorios/relatorios': '/pages/relatorios',
  '/relatorios/atividades': '/pages/relatorios',
  '/relatorios/lucroporperiodo': '/pages/relatorios',
  '/relatorios/lucro-por-periodo': '/pages/relatorios',
  '/lucroporperiodo': '/pages/relatorios',
  '/lucro-por-periodo': '/pages/relatorios',
  '/balanco': '/pages/relatorios',
  '/relatorios/balanco': '/pages/relatorios',
  '/relatorios/relatorio-operacional-financeiro-de-atividades': '/pages/relatorios',
  '/relatorio-operacional-financeiro-de-atividades': '/pages/relatorios',
  '/timesuporte': '/pages/time-de-suporte',
  '/timesuporte/timesuporte': '/pages/time-de-suporte',
  '/timedesuporte': '/pages/time-de-suporte',
  '/time-de-suporte': '/pages/time-de-suporte',
  '/time-de-suporte/time-de-suporte': '/pages/time-de-suporte',
  '/suporte': '/pages/time-de-suporte',
  '/suporte/time-de-suporte': '/pages/time-de-suporte',
  '/suporte/timedesuporte': '/pages/time-de-suporte',
  '/timedesuporte/timedesuporte': '/pages/time-de-suporte',
};

const iconMap = {
  propostas: 'file-empty',
  'verificar contas': 'license',
  freelancers: 'users',
  'time de suporte': 'phone-handset',
  usuarios: 'users',
  'cadastro freelancer': 'user',
  clientes: 'users',
  cadastros: 'menu-circle',
  relatorios: 'chart-bars',
  'contas pendentes': 'clock',
  'contas aprovadas': 'checkmark-circle',
  'contas rejeitadas': 'cross-circle',
  'lancar atividade': 'briefcase',
  'atividades ativas': 'briefcase',
  'minhas atividades': 'briefcase',
  'meu atividades': 'briefcase',
  'lancar em lote': 'briefcase',
  'atividade pendente': 'clock',
  metricas: 'chart-bars',
  balanco: 'chart-bars',
  'lucro por periodo': 'chart-bars',
};

const normalizeKey = value => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-zA-Z0-9]+/g, '-')
  .replace(/(^-|-$)/g, '')
  .toLowerCase();

const normalizeRouteKey = (value) => {
  const rawValue = String(value || '').trim();

  if (!rawValue) {
    return '';
  }

  const sanitizedValue = rawValue
    .replace(/^https?:\/\/[^/]+/i, '')
    .replace(/[?#].*$/, '');

  const segments = sanitizedValue
    .split('/')
    .map(segment => normalizeKey(segment))
    .filter(Boolean);

  return segments.length ? `/${segments.join('/')}` : '';
};

const resolveIcon = label => iconMap[normalizeKey(label).replace(/-/g, ' ')] || 'menu-circle';

const resolveRoute = (url, label) => {
  if (!url) {
    const normalizedLabel = normalizeKey(label).replace(/-/g, ' ');

    if (normalizedLabel === 'time de suporte') {
      return '/pages/time-de-suporte';
    }

    return '';
  }

  const normalizedUrl = normalizeRouteKey(url);

  if (normalizedUrl.startsWith('/pages/')) {
    return normalizedUrl;
  }

  if (url.startsWith('/pages/')) {
    return url;
  }

  return routeMap[url] || routeMap[normalizedUrl] || '';
};

const isTwoFaMenuItem = (item) => {
  if (!item) {
    return false;
  }

  if (item.route === '/pages/2fa') {
    return true;
  }

  if (normalizeKey(item.title || item.key) === '2fa') {
    return true;
  }

  if (item.type === 'category' && Array.isArray(item.children)) {
    return item.children.some(child => isTwoFaMenuItem(child));
  }

  return false;
};

const isDashboardMenuItem = (item) => {
  if (!item) {
    return false;
  }

  if (item.route === '/pages/inicio') {
    return true;
  }

  if (normalizeKey(item.title || item.key) === 'dashboard') {
    return true;
  }

  if (item.type === 'category' && Array.isArray(item.children)) {
    return item.children.some(child => isDashboardMenuItem(child));
  }

  return false;
};

const sortMenuItems = (items = []) => [...items]
  .map((item) => {
    if (item?.type === 'category' && Array.isArray(item.children)) {
      return {
        ...item,
        children: sortMenuItems(item.children),
      };
    }

    return item;
  })
  .sort((left, right) => {
    const leftIsDashboard = isDashboardMenuItem(left);
    const rightIsDashboard = isDashboardMenuItem(right);
    const leftIsTwoFa = isTwoFaMenuItem(left);
    const rightIsTwoFa = isTwoFaMenuItem(right);

    if (leftIsDashboard && !rightIsDashboard) {
      return -1;
    }

    if (!leftIsDashboard && rightIsDashboard) {
      return 1;
    }

    if (leftIsTwoFa && !rightIsTwoFa) {
      return 1;
    }

    if (!leftIsTwoFa && rightIsTwoFa) {
      return -1;
    }

    return (left?.title || '').localeCompare(right?.title || '', 'pt-BR');
  });

const buildApiSubMenuItem = (item, parentKey) => ({
  type: 'link',
  key: `${parentKey}-${normalizeKey(item.label || item.id)}`,
  title: item.label || 'Menu',
  icon: resolveIcon(item.label),
  route: resolveRoute(item.url, item.label),
});

const buildApiMenuItem = (item) => {
  const itemKey = normalizeKey(item.label || item.id);
  const children = Array.isArray(item.subMenu)
    ? item.subMenu.map(subItem => buildApiSubMenuItem(subItem, itemKey))
    : [];

  if (children.length > 0) {
    return {
      type: 'category',
      key: itemKey,
      title: item.label || 'Menu',
      icon: resolveIcon(item.label),
      children,
    };
  }

  return {
    type: 'link',
    key: itemKey,
    title: item.label || 'Menu',
    icon: resolveIcon(item.label),
    route: resolveRoute(item.url, item.label),
  };
};

export const buildMenuConfig = (apiMenu = [], session = null) => {
  const dynamicMenu = Array.isArray(apiMenu)
    ? apiMenu.map(buildApiMenuItem).filter(Boolean)
    : [];
  const hasFreelancerActivitiesMenu = dynamicMenu.some(item => item?.route === '/pages/minhas-atividades-freelancer');
  const hasFreelancerMetricsMenu = dynamicMenu.some(item => item?.route === '/pages/metricas-freelancer');
  const nextMenu = [...dynamicMenu];

  const hasPropostasMenu = nextMenu.some(item => [item, ...(item.children || [])]
    .some(entry => entry.route === '/pages/propostas'));
  if (canViewPropostas(session) && !hasPropostasMenu) {
    nextMenu.push({
      type: 'link',
      key: 'propostas',
      title: 'Propostas',
      icon: 'file-empty',
      route: '/pages/propostas',
    });
  }

  if (hasFreelancerActivitiesMenu && !hasFreelancerMetricsMenu) {
    nextMenu.push({
      type: 'link',
      key: 'metricas-freelancer',
      title: 'Métricas',
      icon: 'chart-bars',
      route: '/pages/metricas-freelancer',
    });
  }

  return sortMenuItems(nextMenu);
};

export const flattenMenuConfig = (items = [], parents = []) => items.reduce((accumulator, item) => {
  if (!item) {
    return accumulator;
  }

  if (item.type === 'link' && item.route) {
    accumulator.push({
      key: item.key,
      title: item.title || 'Menu',
      icon: item.icon || 'menu-circle',
      route: item.route,
      parents,
    });
  }

  if (item.type === 'category' && Array.isArray(item.children)) {
    accumulator.push(...flattenMenuConfig(item.children, [...parents, item.title || 'Menu']));
  }

  return accumulator;
}, []);

export default [];
